import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { ChapterSwitcherComponent } from '../chapter-switcher/chapter-switcher.component';
import { PageSwitcherComponent } from '../page-switcher/page-switcher.component';
import { MobileToolsBarComponent } from '../mobile-tools-bar/mobile-tools-bar.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        ChapterSwitcherComponent,
        ChapterSwitcherComponent,
        PageSwitcherComponent,
        MobileToolsBarComponent
    ]
})
export class FooterComponent {

    /**
     * Constructor
     * @param {ApplicationStateService} applicationStateService
     */
    constructor(public applicationStateService: ApplicationStateService) {

    }

}
